import { Text, type TextProps } from "@mantine/core"
import type { TSurveyQuestion } from "@/types"

export function QuestionTitle({ question, ...props }: TextProps & { question: TSurveyQuestion }) {
  return (
    <Text fz="xl" fw={500} {...props}>
      {question.title}
    </Text>
  )
}
